import React from "react";
import classNames from "../../../utils/classNames";
import { Entity } from "../../../utils/constants";
import { Property } from "./useDataTable";

interface Props {
  entity: Entity;
  property?: Property<any>;
  isFirst?: boolean;
}

const TableRowCell: React.FC<Props> = ({ isFirst = false, children }) => (
  <td
    className={classNames(
      "px-6 py-3",
      isFirst ? "w-5" : "text-sm text-gray-500 font-medium dark:text-gray-50"
    )}
  >
    {children}
  </td>
);

export default TableRowCell;
